// 归一化金额字段：后端以字符串返回数字，统一转成 number 防止 .toFixed 报错
const MONEY_KEYS = new Set(['amount', 'fee', 'member_fee', 'price', 'total', 'refund_amount', 'paid_amount']);
export function normalizeMoney<T = any>(data: T): T {
  if (Array.isArray(data)) return data.map((item) => normalizeMoney(item)) as unknown as T;
  if (data && typeof data === 'object') {
    const out: Record<string, any> = {};
    for (const [k, v] of Object.entries(data as Record<string, any>)) {
      if (MONEY_KEYS.has(k) && (typeof v === 'string' || typeof v === 'number')) {
        out[k] = Number(v);
      } else {
        out[k] = normalizeMoney(v);
      }
    }
    return out as T;
  }
  return data;
}

// API 封装：同源部署（静态前端 + /api.php），自动携带 Session Cookie 与 CSRF 令牌

let csrfToken = '';

export function setCsrfToken(token: string) {
  csrfToken = token;
}

export function getCsrfToken(): string {
  return csrfToken;
}

export class ApiError extends Error {
  statusCode: number;
  constructor(message: string, statusCode = 0) {
    super(message);
    this.statusCode = statusCode;
  }
}

export async function api<T = any>(action: string, params: Record<string, any> = {}, method: 'GET' | 'POST' = 'GET'): Promise<T> {
  const url = new URL('/api.php', window.location.origin);
  url.searchParams.set('action', action);
  const opts: RequestInit = { method, headers: {} as Record<string, string> };

  if (method === 'GET') {
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') url.searchParams.set(k, String(v));
    });
  } else {
    (opts.headers as Record<string, string>)['Content-Type'] = 'application/json';
    opts.body = JSON.stringify(params);
  }
  if (csrfToken) (opts.headers as Record<string, string>)['X-CSRF-Token'] = csrfToken;

  const resp = await fetch(url.toString(), opts);
  let j: any = {};
  try { j = await resp.json(); } catch { /* ignore */ }
  if (j.csrf_token) setCsrfToken(j.csrf_token);
  if (j.status !== 'success') {
    throw new ApiError(j.message || '请求失败（' + resp.status + '）', resp.status);
  }
  return normalizeMoney(j.data) as T;
}

// 文件上传（multipart/form-data）
export async function apiForm<T = any>(action: string, form: FormData): Promise<T> {
  const url = new URL('/api.php', window.location.origin);
  url.searchParams.set('action', action);
  const opts: RequestInit = { method: 'POST', body: form };
  if (csrfToken) opts.headers = { 'X-CSRF-Token': csrfToken } as Record<string, string>;
  const resp = await fetch(url.toString(), opts);
  let j: any = {};
  try { j = await resp.json(); } catch { /* ignore */ }
  if (j.csrf_token) setCsrfToken(j.csrf_token);
  if (j.status !== 'success') throw new ApiError(j.message || '上传失败（' + resp.status + '）', resp.status);
  return normalizeMoney(j.data) as T;
}

// 支付状态中文映射
export const PAY_STATUS_TEXT: Record<string, string> = {
  unpaid: '待支付',
  paid: '已支付',
  refunding: '退款中',
  refunded: '已退款',
};

export const AUDIT_STATUS_TEXT: Record<string, string> = {
  pending_audit: '待审核',
  approved: '已通过',
  rejected: '已驳回',
};
